/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index autocomplete to autogenerate all the components and extensions
 * Used by "prepareAutocompletes"
 */

import Autocomplete from './autocomplete/Autocomplete'
export * from './autocomplete/Autocomplete'
export default Autocomplete
